import React, { useEffect } from "react";

function LogoutRedirector() {
    useEffect(() => {
        window.scrollTo(0, 0);  // Start the page at the top of the page.

        function onRedirect(e) {
            // Clear the entire local storage.
            localStorage.clear();

            // Do not use `Link` but instead use the `window.location` change
            // to fix the issue with the `TopNavigation` component to restart.
            // If you use use `Link` then when you redirect to the navigation then
            // the menu will not update.
            window.location.href = "/login";
        }

        setTimeout(onRedirect, 250);
    });

    return (
        <div class="container column is-12">
            <div class="section">
                <section class="hero is-fullheight">
                    <div class="hero-body">

                        <div class="container">
                            <div class="columns is-centered">
                                <div class="column is-one-third-tablet">
                                    <h1 className="is-size-1">LOGGING OFF...</h1>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </div>
    );
}

export default LogoutRedirector;
